import React from 'react';
import PropTypes from 'prop-types';
import {
	Grid
} from '@material-ui/core';
import {Breadcrumbs} from "../../../components/Breadcrumbs";
import {useTranslation} from "react-i18next";
import {RefreshButton} from "../../../components/RefreshButton";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import {Download as DownloadIcon} from "react-feather";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {},
  action: {
    marginBottom: theme.spacing(1),
    '& + &': {
      marginLeft: theme.spacing(1)
    }
  }
}));

const Header = ({onDownload, onRefresh}) => {
    const { t }  = useTranslation();
    const classes = useStyles();

	const currentPath = [
        { 'name' : t('Fines'), 'url' : '/app/fines'}
    ];

	return (
		<Grid
			container
			spacing={3}
			justifyContent="space-between"
		>
            <Breadcrumbs path={currentPath} />
            <Grid item>
                <RefreshButton onClick={onRefresh} />
                <Button className={classes.action} onClick={onDownload}
                    startIcon={
                      <SvgIcon fontSize="small">
                        <DownloadIcon />
                      </SvgIcon>
                    }
                  >
                      {t('Export')}
                </Button>
            </Grid>
		</Grid>
	);
};

Header.propTypes = {
	className: PropTypes.string
};

export default Header;
